import actionTypes from 'constants/appConstants';
import scrollTo from 'lib/utils/scrollTo';

export const showAppFatalError = (content) => dispatch => {
  dispatch({
    type: actionTypes.SHOW_APP_FATAL_ERROR, payload: content
  });
  scrollTo(0);
};

export const hideAppFatalError = () => dispatch => dispatch({
  type: actionTypes.HIDE_APP_FATAL_ERROR
});

export const showAppGlobalInfo = (content) => dispatch => dispatch({
  type: actionTypes.SHOW_APP_INFO, payload: content
});

export const hideAppGlobalInfo = () => dispatch => dispatch({
  type: actionTypes.HIDE_APP_INFO
});



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/appActions.js